import React, {Component} from 'react'
import Included from '../Included'
class DataTables extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <section>
        <a className="anchor" id="environmentbanners"></a>
        <h2>Environment Banners</h2>
        { this.props.staticVersion === false ? (
          <Included onClick={() => this.props.onIncludeClick()} included={this.props.included}/>
        ) : ( '' ) }
        <br/>
        <p>Include beneath your navigation for high visibility of current environment</p>
        <div className="env-banner env-banner--dev"></div>
        <br/>
        <div className="env-banner env-banner--qa"></div>
        <br/>
        <div className="env-banner env-banner--nr"></div>
        <br/>
        <div className="env-banner env-banner--nr-test"></div>
        <br/>
        <div className="env-banner env-banner--pp"></div>
        <br/>
        <div className="env-banner env-banner--cert"></div>
        <br/>

		    <button type="button" className="btn btn--secondary show-code">
          <i className="fa fa-plus"></i>View source
        </button>
        <br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="env-banner env-banner--dev"></div>
<div class="env-banner env-banner--qa"></div>
<div class="env-banner env-banner--nr"></div>
<div class="env-banner env-banner--nr-test"></div>
<div class="env-banner env-banner--pp"></div>
<div class="env-banner env-banner--cert"></div>`}</code></pre>
		<br/>
		<hr/>

      </section>
    )
  }
}

export default DataTables



// WEBPACK FOOTER //
// ./styleguide/components/sections/EnvironmentBanners.js